// InsuranceLogos: loghi assicurazioni convenzionate
export default function InsuranceLogos() {
  const insurances = [
    { src: '/ottica-bellodi-centro-ottico-torino-previmedical-assicurazione.svg', alt: 'Ottica Bellodi - Centro Ottico Torino - Previmedical Assicurazione' },
    { src: '/ottica-bellodi-centro-ottico-torino-rbm-assicurazione.svg', alt: 'Ottica Bellodi - Centro Ottico Torino - RBM Assicurazione Salute' },
    { src: '/ottica-bellodi-centro-ottico-torino-blue-assistance-assicurazione.svg', alt: 'Ottica Bellodi - Centro Ottico Torino - Blue Assistance Assicurazione' },
    { src: '/ottica-bellodi-centro-ottico-torino-metasalute-assicurazione.svg', alt: 'Ottica Bellodi - Centro Ottico Torino - Metasalute Assicurazione' },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center opacity-80">
      {insurances.map((insurance) => (
        <div key={insurance.alt} className="flex items-center justify-center h-20">
          <img 
            src={insurance.src} 
            alt={insurance.alt} 
            width="160"
            height="64"
            className="max-h-16 w-auto object-contain transition-transform duration-300 hover:scale-105"
            loading="lazy"
          />
        </div>
      ))}
    </div>
  );
}
